import { render, staticRenderFns } from "./ActivityTimeLineItemDocument.vue?vue&type=template&id=134c2452&"
import script from "./ActivityTimeLineItemDocument.vue?vue&type=script&lang=ts&"
export * from "./ActivityTimeLineItemDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports